import { defineComponent as _defineComponent } from 'vue'
import ErrorComponent from "./../error/index.vue";
import PhotoGuidelines from "./guidelines/index.vue";
import PhotoAccept from "./accept/index.vue";
import DocumentAccept from "../documents/accept/index.vue";
import ConnectDevice from "./connectDevice/index.vue";


import { ActionTypes } from "@/store/action-types";
import { useStore } from "@/store";
import { Steps, Errors } from "@/@types";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useMobileDetection } from "vue3-mobile-detection";

interface Props {
  uuid: string;
  sessionType: string;
  lang: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    uuid: null,
    sessionType: null,
    lang: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  uuid: string;
  sessionType: string;
  lang: string;
};

const store = useStore();
const route = useRoute();

const { isMobile } = useMobileDetection();

const step = computed(() => store.state.step);
const error = computed(() => store.state.error);

if (isMobile()) {
  const returnUrl = route.query.returnUrl?.toString();
  store.dispatch(ActionTypes.INIT, { uuid: props.uuid, sessionType: props.sessionType, returnUrl: returnUrl! });
}

const __returned__ = { store, route, props, isMobile, step, error, ErrorComponent, PhotoGuidelines, PhotoAccept, DocumentAccept, ConnectDevice, get ActionTypes() { return ActionTypes }, get useStore() { return useStore }, get Steps() { return Steps }, get Errors() { return Errors }, computed, get useRoute() { return useRoute }, get useMobileDetection() { return useMobileDetection } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})